import React, { FunctionComponent } from "react";
import { Trans, t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Rubriek } from "components/aangifte/Rubriek";
import { Rubriek as RubriekType } from "domain/store/rubriekenReducer";
import { useQuickEntryRubriek } from "./useQuickEntryRubriek";
import {formatAmount, formatCurrency, formatPct} from "../../../utils/format-utils";
import {ValueBuitenland} from "../../../domain/types";

export interface Props {
  code: string;
}

export const EnteredTaxCodeRow: FunctionComponent<Props> = ({ code }) => {
  const { i18n } = useLingui();
  const { rubriek: quickEntryRubriek } = useQuickEntryRubriek(code);
  const formatValue = (rubriek: RubriekType) => {
    switch (rubriek.type) {
      case "bool":
        return rubriek.default === "yes" ? <Trans>Ja</Trans> : <Trans>Nee</Trans>;
      case "pct":
        return formatPct(Number(rubriek.value));
      case "num":
        return formatAmount(Number(rubriek.value));
      case "date":
        return rubriek.value;
      case "buitenland":
        const v = rubriek.value as ValueBuitenland;
        const vol = formatCurrency(Number(v.Vol));
        const vrij = formatCurrency(Number(v.Vrijgesteld));
        const verl = formatCurrency(Number(v.Verlaagd));
        const heeftBuitenland = Number(v.Vrijgesteld) > 0 || Number(v.Verlaagd) > 0;
        return <div className="colamount">
          {v.Vol && heeftBuitenland ? <span>{vol} (<Trans>Bel.</Trans>)<br /></span> : null}
                {v.Vol && !heeftBuitenland ? <span>{vol}</span> : null}
                {v.Vrijgesteld ? <span>{vrij} (<Trans>vrij.</Trans>)<br /></span> : null}
                {v.Verlaagd ? <span>{verl} (<Trans>verm.</Trans>)<br /></span> : null}
              </div>;
      default:
        return formatCurrency(Number(rubriek.value));
    }
  };

  return (
    <Rubriek code={code}>
      {({ updateValue, rubriek }) => {
        if (rubriek.value === undefined) return null;
        return (
          <div className="codesrow" style={{"paddingLeft": "4px"}}>
            <div className="colcode">{code}</div>
            <div className="colamount">{formatValue(rubriek)}</div>
            <div className="coldescr">{quickEntryRubriek?.name}</div>
            <div className="coldel">
              <button
                title={i18n._(t`Codes verwijderen`)}
                onClick={() => {
                  updateValue(undefined);
                }}
                type="button"
              >
                X
              </button>
            </div>
          </div>
        );
      }}
    </Rubriek>
  );
};

EnteredTaxCodeRow.displayName = "EnteredTaxCodeRow";
